import type { BonusModalTemplateProps } from '~/domains/promotions/domains/promoCodes/components/PromotionBonusModal/types';

export type SignUpFormValues = {
  email: string;
  password: string;
  handle: string;
  promoOrReferralCode: string;
  emailVerificationCode?: string;
  firstName?: string;
  lastName?: string;
  _referralCodeValue: string;
  _promoCodeValue: string;
  _promoModalProps?: Omit<BonusModalTemplateProps, 'onAction' | 'isOpen' | 'onClose'>;
};

export type KYCFormValues = {
  firstName: string;
  lastName: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  phone: string;
  verificationCode?: string;
  dob: {
    month: string;
    day: string;
    year: string;
  };
};

export const enum KYCDetailsMode {
  VERIFY = 'verify',
  MANUAL = 'manual',
  EDIT = 'edit',
}

export type UseSignUpParams = {
  formValues: SignUpFormValues;
};

export type UseKYCParams = {
  formValues: KYCFormValues;
};
